import { LoginForm } from "@/components/login-form";
import { Storage } from "@/services/storage-services";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import Logo from "../../assets/texpress.png";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form, FormField, FormControl, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Eye, EyeClosed, Loader2, Mail } from "lucide-react";
import { HiAnnotation } from "react-icons/hi";
import { AnnotationHeartIcon, AnnotationIcon, BriefcaseIcon, PasscodeIcon, PhoneIcon, PhoneIcon1, PhoneIcon2 } from "@/assets";
import { useMutation } from "@tanstack/react-query";
import { SignUp } from "@/services/Auth.service";
import { ToastMessage, type } from "@/lib/toastr";
import { PasswordError } from "@/components/PasswordError";

export const formSchema = z.object({
  firstName: z.string().nonempty().min(3, { message: "First Name must be minimum of 3 characters" }),
  lastName: z.string().nonempty().min(3, { message: "Last Name must be minimum of 3 characters" }),
  businessName: z.string().nonempty().min(3, { message: "Business Name must be minimum of 3 characters" }),
  phone: z.string().nonempty().min(11, { message: "Phone Number must be minimum of 11 characters" }),
  bvn: z.string().nonempty().min(11, { message: "BVN must be 11 characters long" }),
  inviteToken: z.string().nonempty(),
  email: z.string().email({ message: "Please enter a valid email address!" }),
  password: z.string().nonempty({ message: "Password must be at least 8 characters" }),
});

const CreateAccount = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate()
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      businessName: "",
      phone: "",
      bvn: "",
      inviteToken: "",
      email: "",
      password: "",
    },
  });


  const mutation = useMutation({
    mutationFn: (data: any) => SignUp(data),
    mutationKey: ['register'],

    onSuccess: (res) => {
      if (res.data.statusCode === 201) {
        // navigate('/');
        navigate(`/VerifyEmail`, { state: { email } });
        // params: { email: email }
      }
    },
    onError: (err: any) => {
      ToastMessage(type.ERROR, err.response.data.message);


    }
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    setEmail(data?.email)
    console.log(data);
    mutation.mutate(data)
  }

  return (
    <div className="flex flex-col  items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col items-center gap-6">
        <Link to="/">
          <img src={Logo} className="h-10" />
        </Link>
        <div className={cn("flex flex-col gap-6 ",
          // className
        )}
        // {...props}
        >
          <Card className="w-full lg:w-[542px] p-6">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-medium text-primary">Create Express account</CardTitle>
              <CardDescription className="">
                Enter your credentials to access your account
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="grid gap-6">
                  <div className="grid gap-5">
                    <div className="grid grid-cols-2 gap-8">
                      <FormField
                        control={form.control}
                        name="firstName"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.firstName === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">First Name</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter First Name"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <AnnotationIcon />
                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                      <FormField
                        control={form.control}
                        name="lastName"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.lastName === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">Last Name</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter Last Name"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <AnnotationIcon />

                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-8">
                      <FormField
                        control={form.control}
                        name="businessName"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.businessName === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">Business Name</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter Business Name"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <BriefcaseIcon />
                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                      <FormField
                        control={form.control}
                        name="phone"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.phone === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">Phone Number</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter Phone Number"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <PhoneIcon1 />

                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-8">
                      <FormField
                        control={form.control}
                        name="bvn"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.bvn === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">BVN</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter BVN"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <PasscodeIcon />
                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                      <FormField
                        control={form.control}
                        name="inviteToken"
                        render={({ field }) => {
                          return (
                            <FormItem>
                              <div
                                className={cn(
                                  "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  form.formState.errors?.inviteToken === undefined
                                    ? "border-input-border"
                                    : "border-destructive"
                                )}
                              >
                                <div className="flex flex-col w-full">
                                  <FormLabel className="text-xs">Invite Token</FormLabel>

                                  <FormControl>
                                    <Input
                                      type='text'
                                      className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                      {...field}
                                      placeholder="Enter Invite Token"
                                    />
                                  </FormControl>
                                </div>
                                <div className="w-4 h-4 text-muted-foreground">
                                  <AnnotationHeartIcon />

                                </div>
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                    </div>
                    <FormField
                      control={form.control}
                      name="email"
                      render={({ field }) => {
                        return (
                          <FormItem>
                            <div
                              className={cn(
                                "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                form.formState.errors?.email === undefined
                                  ? "border-input-border"
                                  : "border-destructive"
                              )}
                            >
                              <div className="flex flex-col w-full">
                                <FormLabel className="text-xs">Email</FormLabel>

                                <FormControl>
                                  <Input
                                    type="email"
                                    className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                    {...field}
                                    placeholder="Enter Email Address"
                                  />
                                </FormControl>
                              </div>
                              <div className="w-4 h-4 text-muted-foreground">
                                {/* <AnnotationIcon /> */}
                                <Mail className="w-5 h- text-[#A1A5AD]" />
                              </div>
                            </div>
                            <FormMessage />
                          </FormItem>
                        );
                      }}
                    />
                    <FormField
                      control={form.control}
                      name="password"
                      render={({ field }) => {
                        return (
                          <FormItem>
                            <div
                              className={cn(
                                "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                form.formState.errors?.password === undefined
                                  ? "border-input-border"
                                  : "border-destructive"
                              )}
                            >
                              <div className="flex flex-col w-full">
                                <FormLabel className="text-xs">
                                  Password
                                </FormLabel>

                                <FormControl>
                                  <Input
                                    type={!show ? "password" : "text"}
                                    placeholder=""
                                    className="w-full h-6 px-0 py-0 border-none outline-none placeholder:py-0 placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                    {...field}
                                  />
                                </FormControl>
                              </div>
                              <div
                                className=" left-2.5 top-2.5 h-4 w-4 text-muted-foreground"
                                onClick={() => setShow(!show)}
                              >
                                {!show ? (
                                  <EyeClosed />
                                ) : (
                                  <Eye className="w-5 h-5" />
                                )}
                              </div>
                            </div>
                            <FormMessage />
                          </FormItem>
                        );
                      }}
                    />
                    <PasswordError
                      passwordErrorLowerCaseChar={form.watch("password")}
                      passwordErrorMin={form.watch("password")}
                      passwordErrorUpperCaseChar={form.watch("password")}
                      passwordErrorHasNumber={form.watch("password")}
                      passwordErrorSpecialChar={form.watch("password")}
                    />


                    <Button
                      type="submit"
                      variant="default"
                      className="w-full bg-gradient-to-r from-primary to-primary-2 h-14 rounded-[10px] p-[10px]  ring-transparent focus-visible:ring-transparent"
                      disabled={
                        !form.formState.isDirty ||
                        !form.formState.isValid ||
                        form.formState.isSubmitting ||
                        mutation.isPending
                      }
                    >
                      {mutation.isPending && (
                        <Loader2 className="text-white animate-spin" />
                      )}
                      Create Account
                    </Button>
                  </div>
                </form>
              </Form>
            </CardContent>
          </Card>
          <Link to='/'
            className="flex items-center justify-center border-[1px] border-[#DAD3DA] h-14 p-2.5 rounded-[10px] text-[#761873] text-sm font-medium"
          >Already own an account? Log In</Link>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
